import React from 'react';
import {Link} from "react-router-dom";


const Nav = () => {
    return (
        <ul className="mainmenu">
            {/* <li className="has-droupdown"><Link to="#">Home</Link>
                <ul className="submenu">
                    <li><Link to="/business-consulting">Business Consulting</Link></li>
                    <li><Link to="/business-consulting-2">Business Consulting 02</Link></li>
                    <li><Link to="/corporate">Corporate</Link></li>
                    <li><Link to="/business">Business</Link></li>
                    <li><Link to="/digital-agency">Digital Agency</Link></li>
                    <li><Link to="/finance">Finance</Link></li>
                    <li><Link to="/company">Company</Link></li>
                    <li><Link to="/marketing">Marketing Agency</Link></li>
                    <li><Link to="/travel-agency">Travel Agency</Link></li>
                    <li><Link to="/consulting">Consulting</Link></li>
                    <li><Link to="/seo-agency">SEO Agency</Link></li>
                    <li><Link to="/personal-portfolio">Personal Portfolio</Link></li>
                    <li><Link to="/event-conference">Event Conference</Link></li>
                    <li><Link to="/creative-portfolio">Creative Portfolio</Link></li>
                    <li><Link to="/freelancer">Freelancer</Link></li>
                    <li><Link to="/international-consulting">International Consulting</Link></li>
                    <li><Link to="/startup">Startup</Link></li>
                    <li><Link to="/web-agency">Web Agency</Link></li>
                </ul>
            </li> */}
            

            <li><Link to="/">Home</Link></li>

            {/* <li><Link to="/about-us">About</Link></li> */}
            <li><Link to="/about-us">About</Link></li>
           <li className="has-droupdown">
    <Link to="/our-services">Services</Link>

    <ul className="submenu">

        {/* Level 1 Item with Level 2 Dropdown */}
        <li className="has-droupdown">
            <Link to="/our-services?filter=development services">
                Development Services
            </Link>

            {/* Second Level Submenu */}
            <ul className="submenu sub-level">
                <li>
                    <Link to={process.env.PUBLIC_URL + `/services/enterprise-application-development`}>
                        Enterprise Application Development
                    </Link>
                </li>
                <li>
                    <Link to={process.env.PUBLIC_URL + `/services/web-mobile-app-design`}>
                       Web and Mobile App Development
                    </Link>
                </li>
                <li>
                    <Link to="{process.env.PUBLIC_URL + `/services/content-management-system`}">
                       Content Management System CMS Development
                    </Link>
                </li>
                <li>
                    <Link to={process.env.PUBLIC_URL + `/services/ecommerce`}>
                        E-commerce Development
                    </Link>
                </li>
                <li>
                    <Link to={process.env.PUBLIC_URL + `/services/custom-software-development-2`}>
                        Custom Software Development

                    </Link>
                </li>
            </ul>
        </li>

        {/* Normal Level 1 Items */}
        {/* Level 1 Item with Level 2 Dropdown */}
        <li className="has-droupdown">
            <Link to="/our-services?filter=online marketing strategies">
                Online Marketing Strategies
            </Link>
             {/* Second Level Submenu */}
            <ul className="submenu sub-level">
                <li>
                    <Link to={process.env.PUBLIC_URL + `/services/content-marketing`}>
                       Content Marketing
                    </Link>
                </li>
                <li>
                    <Link to={process.env.PUBLIC_URL + `/services/social-media-marketing`}>
                       Social Media Marketing
                    </Link>
                </li>
                  <li>
                    <Link to={process.env.PUBLIC_URL + `/services/display-marketing`}>
                       Display Marketing
                    </Link>
                </li>
                <li>
                    <Link to={process.env.PUBLIC_URL + `/services/pay-per-click`}>
                      Pay-Per-Click (PPC) Marketing
                    </Link>
                </li>
                <li>
                    <Link to={process.env.PUBLIC_URL + `/services/email-marketing`}>
                      Email Marketing Solutions
                    </Link>
                </li>
                 <li>
                    <Link to={process.env.PUBLIC_URL + `/services/seo`}>
                      SEO and SEM Optimization
                    </Link>
                </li>
            </ul>
        </li>
        {/* Level 1 Item with Level 2 Dropdown */}
        <li className="has-droupdown">
            <Link to="/our-services?filter=creative design solutions">
                Creative Design Solutions
            </Link>
             {/* Second Level Submenu */}
            <ul className="submenu sub-level">
                <li>
                    <Link to={process.env.PUBLIC_URL + `/services/prototype-wireframing`}>
                      Prototype and Wireframing
                    </Link>
                </li>
                <li>
                    <Link to={process.env.PUBLIC_URL + `/services/graphic-motion-design`}>
                      Graphic and Motion Design
                    </Link>
                </li>
                <li>
                    <Link to={process.env.PUBLIC_URL + `/services/ui-ux-design`}>
                      UI and UX Design
                    </Link>
                </li>
                <li>
                    <Link to={process.env.PUBLIC_URL + `/services/mobile-app-design`}>
                      Innovative Mobile App Design
                    </Link>
                </li>
                <li>
                    <Link to={process.env.PUBLIC_URL + `/services/logo-branding`}>
                      Logo and Branding Design
                    </Link>
                </li>
                <li>
                    <Link to={process.env.PUBLIC_URL + `/services/video-production-2`}>
                      Professional Video Production
                    </Link>
                </li>
                <li>
                    <Link to={process.env.PUBLIC_URL + `/services/graphic-print-design`}>
                      Graphic and Print Design
                    </Link>
                </li>
            </ul>
        </li>
        {/* Level 1 Item with Level 2 Dropdown */}
        <li className="has-droupdown">
            <Link to="/our-services?filter=business growth solutions">
                Business Growth Solutions
            </Link>
             {/* Second Level Submenu */}
            <ul className="submenu sub-level">
               <li>
                    <Link to={process.env.PUBLIC_URL + `/services/data-analytics-insights`}>
                     Data Analytics and Insights

                    </Link>
                </li>
                <li>
                    <Link to={process.env.PUBLIC_URL + `/services/crm-erp-implementation`}>
                      CRM and ERP Implementation
                    </Link>
                </li>
                <li>
                    <Link to={process.env.PUBLIC_URL + `/services/it-consulting-strategy`}>
                      IT Consulting and Strategy
                    </Link>
                </li>
                <li>
                    <Link to={process.env.PUBLIC_URL + `/services/marketing-flexibility`}>
                      Marketing Flexibility Services
                    </Link>
                </li>
                <li>
                    <Link to={process.env.PUBLIC_URL + `/services/advertising-strategy`}>
                     Advertising Strategy Consulting
                    </Link>
                </li>
                <li>
                    <Link to={process.env.PUBLIC_URL + `/services/web-audit-practices`}>
                      Comprehensive Web Audits
                    </Link>
                </li>
            </ul>
        </li>
        {/* Level 1 Item with Level 2 Dropdown */}
        <li className="has-droupdown">
            <Link to="/our-services?filter=advanced technology services">
                Advanced Technology Services
            </Link>
             {/* Second Level Submenu */}
            <ul className="submenu sub-level">
                <li>
                    <Link to={process.env.PUBLIC_URL + `/services/ai-machine-learning`}>
                      AI and Machine Learning
                    </Link>
                </li>
                <li>
                    <Link to={process.env.PUBLIC_URL + `/services/devops-automation`}>
                      DevOps and Automation
                    </Link>
                </li>
                <li>
                    <Link to={process.env.PUBLIC_URL + `/services/blockchain-solutions`}>
                      Blockchain Solutions
                    </Link>
                </li>
                <li>
                    <Link to={process.env.PUBLIC_URL + `/services/big-data-analytics`}>
                      Big Data Analytics
                    </Link>
                </li>
                <li>
                    <Link to={process.env.PUBLIC_URL + `/services/hosting`}>
                      Secure Hosting Solutions
                    </Link>
                </li>
            </ul>
        </li>
        {/* Level 1 Item with Level 2 Dropdown */}
        <li className="has-droupdown">
            <Link to="/our-services?filter=it support services">
                IT Support Services
            </Link>
            <ul className="submenu sub-level">
                <li>
                    <Link to={process.env.PUBLIC_URL + `/services/cloud-support-maintenance`}>
                      Cloud Support and Maintenance
                    </Link>
                </li>
                <li>
                    <Link to={process.env.PUBLIC_URL + `/services/managed-it-services`}>
                      Managed IT Services
                    </Link>
                </li>
                <li>
                    <Link to={process.env.PUBLIC_URL + `/services/cybersecurity-services`}>
                      Cybersecurity Services
                    </Link>
                </li>

            </ul>
        </li>

    </ul>
</li>

            <li><Link to="/products">Products</Link></li>
            

{/* 
            <li className="with-megamenu"><Link to="#">Elements</Link>
                <div className="rn-megamenu">
                    <div className="wrapper">
                        <div className="row row--0">
                            <div className="col-lg-3 single-mega-item">
                                <ul className="mega-menu-item">
                                    <li><Link to="/button">Button</Link></li>
                                    <li><Link to="/service">Service</Link></li>
                                    <li><Link to="/counter">Counter</Link></li>
                                    <li><Link to="/progressbar">Progressbar</Link></li>
                                    <li><Link to="/accordion">Accordion</Link></li>
                                    <li><Link to="/social-share">Social Share</Link></li>
                                    <li><Link to="/blog-grid">Blog Grid</Link></li>
                                </ul>
                            </div>
                            <div className="col-lg-3 single-mega-item">
                                <ul className="mega-menu-item">
                                    <li><Link to="/team">Team</Link></li>
                                    <li><Link to="/portfolio">Portfolio</Link></li>
                                    <li><Link to="/testimonial">Testimonial</Link></li>
                                    <li><Link to="/timeline">Timeline</Link></li>
                                    <li><Link to="/tab">Tab</Link></li>
                                    <li><Link to="/pricing">Pricing</Link></li>
                                    <li><Link to="/split">Split Section</Link></li>
                                </ul>
                            </div>
                            <div className="col-lg-3 single-mega-item">
                                <ul className="mega-menu-item">
                                    <li><Link to="/call-to-action">Call To Action</Link></li>
                                    <li><Link to="/video-popup">Video</Link></li>
                                    <li><Link to="/gallery">Gallery</Link></li>
                                    <li><Link to="/contact">Contact</Link></li>
                                    <li><Link to="/brand">Brand</Link></li>
                                    <li><Link to="/portfolio">Portfolio</Link></li>
                                    <li><Link to="/error">404</Link></li>
                                </ul>
                            </div>
                            <div className="col-lg-3 single-mega-item">
                                <ul className="mega-menu-item">
                                    <li><Link to="/advance-tab">Advance Tab <span className="rn-badge-card">Hot</span></Link></li>
                                    <li><Link to="#">Brand Carousel <span className="rn-badge-card">Comming</span></Link></li>
                                    <li><Link to="advance-pricing">Advance Pricing <span className="rn-badge-card">Hot</span></Link></li>
                                    <li><Link to="/portfolio-details/1">Portfolio Details</Link></li>
                                    <li><Link to="/blog/sample-blog">Blog Details</Link></li>
                                    <li><Link to="/error">404 Page</Link></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </li> */}

            <li className="has-droupdown"><Link to="/blog">Blog</Link>
                {/* <ul className="submenu">
                    <li><Link to="/blog-grid">Blog Grid</Link></li>
                    <li><Link to="/blog-grid-sidebar">Blog Grid Sidebar</Link></li>
                    <li><Link to="/blog-list-view">Blog List View</Link></li>
                    <li><Link to="/blog-list-sidebar">Blog List View Sidebar</Link></li>
                </ul> */}
            </li>
            <li><Link to="/Portfolio">Portfolio</Link></li>

            {/* <li className="has-droupdown"><Link to="#">Portfolio</Link>
                <ul className="submenu">
                    <li><Link to="/portfolio">Portfolio Default</Link></li>
                    <li><Link to="/portfolio-three-column">Portfolio Three Column</Link></li>
                    <li><Link to="/portfolio-full-width">Portfolio Full Width</Link></li>
                    <li><Link to="/portfolio-grid-layout">Portfolio Grid Layout</Link></li>
                    <li><Link to="/portfolio-box-layout">Portfolio Box Layout</Link></li>
                </ul>
            </li> */}

            <li className="has-droupdown"><Link to="/contact">Contact</Link></li>
        </ul>
    )
}
export default Nav;
